import GLightbox from 'glightbox'

export default function init() {
    const lightbox = GLightbox()
}
